import React from 'react'
import { ListGroupItem, Card, CardHeader, CardBody, ListGroup, Row, Col, Button, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'
import UtilSearchBar from '../Util/UtilSearchBar'

/* Manage Educators

  <TeachersCard 
    selectedSchool={this.props.selection.school}
    selectedTeacher={this.props.selection.teacher}
    key='TeachersCard'
    schools={this.props.schools}
    select={this.props.select}
    openModal={this.props.openModal}
    educators={this.props.educators}
    setForceExpanded={this.props.setForceExpanded}
    forceTeacherExpanded={this.props.forceTeacherExpanded}
    handleChange={this.handleChange}
    teacherSearchVal={this.state.teacherSearchVal}
    permissionSchool={permissionSchool}
  />

*/

export default function TeachersCard({
  selectedSchool, selectedTeacher, schools, select, 
  openModal, educators, setForceExpanded, forceTeacherExpanded, handleChange,
  teacherSearchVal, permissionSchool, 
}) {
  let teachersCardBody = null

  if (selectedSchool && schools) {
    // School Administrators
    const school = schools[selectedSchool]
    let adminListGroupItems = []

    if ((!selectedTeacher || forceTeacherExpanded) && permissionSchool) {
      adminListGroupItems.push(
        <ListGroupItem
          key='schoolAdminListGroupItemAdd'
          onClick={() => openModal('addSchoolAdmin')}
          className='m2clickable'
        >
          + Add School Admin
        </ListGroupItem>
      )
    

      if (school.admins && educators) {
        let admins = []
        forOwn(school.admins, (check, adminId) => {
          if (check && educators[adminId]) {
            admins.push(educators[adminId])
          }
        })
        if (admins.length > 0) {
          const sortedAdmins = sortByPropText(admins, 'lastName')
          sortedAdmins.forEach((admin) => {
            adminListGroupItems.push(
              <ListGroupItem
                key={`adminListGroupItem${admin.id}`}
                className='m2clickable m2icon-hover'
                onClick={() => openModal(`record&id=${admin.id}`)}
              >
                {`${admin.firstName} ${admin.lastName}`} <i className="icon-magnifier icons ml-2"></i>
              </ListGroupItem>
            )
          })
        }
      }
    }

    let teachersListGroupItems = []

    if ((!selectedTeacher || forceTeacherExpanded) && permissionSchool) {
      teachersListGroupItems.push(
        <ListGroupItem
          key='teachersListGroupItemAdd'
          onClick={() => openModal('addTeacher')}
          className={'m2clickable'}
        >
          + Add Teacher
        </ListGroupItem>
      )
    }

    if (school.teachers && educators) {
      let teachers = []
      forOwn(school.teachers, (check, teacherId) => {
        if (check) {
          teachers.push(educators[teacherId])
        }
      })
      if (teachers.length > 0) {
        const sortedTeachers = sortByPropText(teachers, 'lastName')
        sortedTeachers.forEach((teacher) => {
          if (teacher) {
            const active = teacher.id === selectedTeacher
            if (active || !selectedTeacher || forceTeacherExpanded) {
              if (active || teacher.fullName.toLowerCase().search(teacherSearchVal.toLowerCase()) > -1) {
                teachersListGroupItems.push(
                  <ListGroupItem
                    key={`teachersListGroupItem${teacher.id}`}
                    active={active}
                    className={'m2clickable'}
                    onClick={
                      active 
                      ? () => openModal(`record&id=${teacher.id}`) 
                      : () => select(teacher.id)
                    }
                  >
                    {`${teacher.firstName} ${teacher.lastName}`}
                    {active ? <i className="icon-magnifier icons ml-2"></i> : null}
                  </ListGroupItem>
                )
              }
            }
          }
        })
      }
    }


    // Teachers

    let teacherSearchBar = null
    if ((!selectedTeacher || forceTeacherExpanded) && permissionSchool) {
      teacherSearchBar = (
        <UtilSearchBar 
          searchIconQ={true}
          searchButtonQ={true}
          searchIconText={'Search'}
          placeholder={'Search teachers...'}
          handleChange={handleChange}
          buttonColor='primary'
          val={teacherSearchVal}
          name={'teacherSearchVal'}
        />

      )
    }
    
    let buttonText = 'Create Registration Code'
    if (school.teacherRegistrationCode) {
      buttonText = `Manage Registration Code: ${school.teacherRegistrationCode}`
    }
  
    let manageRegistrationCode = (
          <Button 
            color='primary'
            onClick={() => openModal('teacherRegistrationCode')}
          >
            {buttonText}
          </Button>
    )

    let importUsers = (
      <Button
        color='secondary'
        onClick={() => openModal('importTeachers')}
        className='ml-2'
      >
        Import
      </Button>
    )

    let buttonRow = null
    if (permissionSchool) {
      buttonRow = (
        <Row className='mb-1'>
          <Col>
            {manageRegistrationCode}
            {importUsers}
          </Col>
        </Row>
      )
    }

    teachersCardBody = (
      <CardBody>
        {buttonRow}
        <ListGroup className='mb-2'>
          {adminListGroupItems}
        </ListGroup>
        {teacherSearchBar}
        <ListGroup>
          {teachersListGroupItems}
        </ListGroup>
      </CardBody>
        
    )

  }

  let icon = (
    <i 
      className="fa fa-minus-circle float-right m2clickable"
      onClick={() => setForceExpanded('forceTeacherExpanded', false)}  
    ></i>
  )
  if (selectedSchool && !forceTeacherExpanded) {
     icon = (
      <i 
        className="fa fa-plus-circle float-right m2clickable" 
        onClick={() => setForceExpanded('forceTeacherExpanded', true)}
      ></i>
    ) 
  } else if (!forceTeacherExpanded) {
    icon = <i className='fa fa-circle float-right'></i>
  }



  return (
    <Card>
      <CardHeader>
        {permissionSchool ? icon : null} Teachers
      </CardHeader>
      {teachersCardBody}
    </Card>
  )


}



// WEBPACK FOOTER //
// ./src/components/Users/TeachersCard.js